import styled from 'styled-components';
import { Captions } from 'components/Typography';
import { SanlamOrange, SanlamDarkOrange } from 'Material-UI/colors';
import { Divider, Grid } from '@material-ui/core';
import { MediumSectionHeader } from 'components/Typography';

const StyledCaptionsBase = styled(Captions)`
  letter-spacing: 0.1px !important;
  line-height: 17px !important;
  font-size: 13px !important;
`;

const StyledCaptions = styled(StyledCaptionsBase)`
  text-align: center !important;
  margin-left: -5px !important;
  margin-right: -5px !important;
  white-space: pre-wrap;
`;

interface ItemStylesType {
  orange?: boolean;
}

const ItemWrapper = styled.div<ItemStylesType>`
  background-color: ${(props) => (props.orange ? SanlamOrange : 'white')};
  border-radius: 6px;
  box-shadow: 0 1px 6px 0 rgba(43, 86, 210, 0.3);
  height: 107px;
  border: ${(props) => (props.orange ? '1px dashed rgba(0,0,0,0.3)' : 'none')};
  width: 104px;
  text-align: center;
  cursor: pointer;
  &: hover {
    opacity: 0.9;
    box-shadow: 0 3px 20px 0 rgba(0, 0, 0, 0.2) !important;
    background-color: ${(props) => (props.orange ? SanlamDarkOrange : 'white')};
  }
`;

const ContentWrapper = styled.div`
  padding: 15px 8px 9px;
`;

const StyledIcon = styled.img`
  margin-bottom: 4px;
  height: 40px;
  width: 40px;
`;
const StyledSmallIcon = styled.img`
  margin-top: 4px;
  margin-bottom: 6px;
  height: 31px;
  width: 32px;
`;
export const ColoredDivider = styled(Divider)`
  && {
    background-color: #979797;
    opacity: 24%;
    left: 0px;
    right: 0px;
    position: absolute;
    margin-top: 10px;
  }
`;
export const StyledGrid = styled(Grid)`
  margin-top: 10px !important;
`;
export const StyledGridButton = styled(Grid)`
  margin-top: 20px !important;
`;
export const MediumSectionHeaderStyled = styled(MediumSectionHeader)`
text-align: center; !important;
`;

export {
  StyledCaptions,
  ItemWrapper,
  ContentWrapper,
  StyledIcon,
  StyledSmallIcon,
  StyledCaptionsBase,
};
